(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.getElementById('Hero-{{ section.id }}');
    if (!hero) return;

    const videos = hero.querySelectorAll('.hero__video');
    if (!videos.length) return;

    videos.forEach((video) => {
      // Make sure flags are set before we try to play
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      const tryPlay = () => {
        const p = video.play();
        if (p && p.catch) {
          p.catch(() => {
            // Autoplay blocked – we just silently fail, user scroll/click will unlock
          });
        }
      };

      // Try once now, and again when tab becomes visible
      if (document.visibilityState === 'visible') tryPlay();

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') tryPlay();
      });

      // Extra nudge after a short delay
      setTimeout(tryPlay, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
